/**
 * @file This module is meant to mirror `invoices-ctrl.js` but outside Angular
 * and in a functional way.
 *
 * The idea would be to migrate here all methods from that controller file.
 */

import { COUNTRIES } from '@hotjar/country-lib';

export interface CompanyDetails {
  company?: string;
  address?: string;
  countryCode?: string;
  vatNumber?: string;
}

export function getCompanyCountryName(companyDetails: CompanyDetails): string | null {
  if (!companyDetails.countryCode) {
    return null;
  }

  return COUNTRIES.find((country) => country.value === companyDetails.countryCode)?.label ?? null;
}
